module.exports = __webpack_public_path__ + "assets/doneCopy@3x.7cd5843a2e95aaa0f080d45f2cd5c95a.png";